import {inject, Injectable, NgZone} from '@angular/core';
import {AuthService} from './auth.service';
import {getStored, setStored} from '../utils/other/utilities';

@Injectable({
    providedIn: 'root'
})
export class AutoLogoutService {

    private readonly MINUTES_UNTIL_AUTO_LOGOUT = 30;
    private readonly CHECK_INTERVAL = 3000;
    private readonly STORE_KEY = 'lastAction';

    private readonly _ngZone: NgZone = inject(NgZone);
    private readonly _authService: AuthService = inject(AuthService);

    constructor() {
        this.initListener();
        this.reset();
        this.initInterval();
    }

    public get lastAction(): number {
        return parseInt(getStored(this.STORE_KEY));
    }

    public set lastAction(value) {
        setStored(this.STORE_KEY, value);
    }

    public initListener(): void {
        this._ngZone.runOutsideAngular(() => {
            document.body.addEventListener('click', () => this.reset());
            document.body.addEventListener('mousemove', () => this.reset());
            document.body.addEventListener('keydown', () => this.reset());
        });
    }

    private initInterval(): void {
        this._ngZone.runOutsideAngular(() => {
            setInterval(() => {
                this.check();
            }, this.CHECK_INTERVAL);
        });
    }

    private reset(): void {
        this.lastAction = Date.now();
    }

    private check(): void {
        const now = Date.now();
        const timeLeft = this.lastAction + this.MINUTES_UNTIL_AUTO_LOGOUT * 60 * 1000;
        const diff = timeLeft - now;
        const isTimeout = diff < 0;

        this._ngZone.run(() => {
            if (isTimeout) {
                this._authService.logout();
            }
        });
    }
}
